import {useContext} from 'react';
import {PopupContext} from 'extensions/viewport/PopupContext';

export function usePopup() {
  return useContext(PopupContext);
}
